/**
 * Units of measure
 */
export enum Unit {
  EARTH_RADII = "Earth Radii",
  KILOMETERS = "km",
  MILES = "m",
}
